// AdSense Blocker - Immediate execution
// eslint-disable-next-line no-console
(function() {
  // Console logging with visibility
  function logBlock (message) {
    // eslint-disable-next-line no-console
    console.warn(`[ADSENSE BLOCKER] ${message}`)
  }

  // More specific AdSense URL patterns to avoid blocking analytics
  function isAdSenseScript (src) {
    if (!src) return false
    return src.includes('googlesyndication.com') || 
           src.includes('adsbygoogle.js') ||
           src.includes('pagead/js/adsbygoogle.js')
  }

  function isAdSenseContent (content) {
    if (!content || typeof content !== 'string') return false
    return content.includes('googlesyndication.com') ||
           content.includes('adsbygoogle.js') ||
           content.includes('pagead/js/adsbygoogle.js') ||
           content.includes('ins class="adsbygoogle"')
  }

  function removeAdSenseScripts () {
    // Only target specific AdSense script URLs
    const scripts = document.querySelectorAll('script[src*="googlesyndication.com"], script[src*="adsbygoogle.js"]')
    let count = 0
    scripts.forEach(script => {
      if (isAdSenseScript(script.src)) {
        script.parentNode.removeChild(script)
        count++
      }
    })
    if (count > 0) logBlock(`Removed ${count} AdSense scripts`)
  }

  function removeAdSenseLinks () {
    // Only target AdSense-specific link URLs
    const links = document.querySelectorAll('link[href*="googlesyndication.com"]')
    let count = 0
    links.forEach(link => {
      link.parentNode.removeChild(link)
      count++
    })
    if (count > 0) logBlock(`Removed ${count} AdSense links`)
  }

  function removeAdSenseElements () {
    // Only remove AdSense-specific elements
    const adsElements = document.querySelectorAll('ins.adsbygoogle, .adsbygoogle-noablate')
    let count = 0
    adsElements.forEach(element => {
      element.parentNode.removeChild(element)
      count++
    })
    if (count > 0) logBlock(`Removed ${count} AdSense elements`)

    // Remove AdSense iframes only
    const iframes = document.querySelectorAll('iframe[src*="googlesyndication.com"], iframe[src*="googleads.g.doubleclick.net"]')
    count = 0
    iframes.forEach(iframe => {
      iframe.parentNode.removeChild(iframe)
      count++
    })
    if (count > 0) logBlock(`Removed ${count} AdSense iframes`)
  }

  function blockAdSenseInjection () {
    // Override document.write to prevent AdSense script injection only
    const originalWrite = document.write
    document.write = function(content) {
      if (isAdSenseContent(content)) {
        logBlock('Blocked AdSense injection attempt')
        return
      }
      originalWrite.apply(document, arguments)
    }

    // Override appendChild to block only AdSense script injections
    const originalAppendChild = Node.prototype.appendChild
    Node.prototype.appendChild = function(node) {
      if (node.nodeName === 'SCRIPT' && 
          node.src && 
          isAdSenseScript(node.src)) {
        logBlock(`Blocked script appendChild: ${node.src}`)
        return node // Return but don't actually append
      }
      return originalAppendChild.call(this, node)
    }

    // Create a MutationObserver to watch for dynamically added AdSense scripts only
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes) {
          mutation.addedNodes.forEach(node => {
            // Check if an AdSense script or link element was added
            if (node.tagName === 'SCRIPT' &&
                node.src &&
                isAdSenseScript(node.src)) {
              node.parentNode.removeChild(node)
              logBlock('Blocked dynamic AdSense script')
            }

            if (node.tagName === 'LINK' &&
                node.href &&
                node.href.includes('googlesyndication.com')) {
              node.parentNode.removeChild(node)
              logBlock('Blocked dynamic AdSense link')
            }

            // Check for AdSense elements only
            if (node.classList &&
                (node.classList.contains('adsbygoogle') ||
                 node.classList.contains('adsbygoogle-noablate'))) {
              node.parentNode.removeChild(node)
              logBlock('Blocked dynamic AdSense element')
            }
          })
        }
      })
    })

    // Start observing the document
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    })
  }

  // Execute the cleanup functions
  function cleanupAdSense () {
    logBlock('Running AdSense cleanup')
    removeAdSenseScripts()
    removeAdSenseLinks()
    removeAdSenseElements()
    blockAdSenseInjection()

    // Run periodically to catch delayed injections
    setInterval(function() {
      removeAdSenseScripts()
      removeAdSenseLinks()
      removeAdSenseElements()
    }, 1000) // Run more frequently (every second)
  }

  // Run immediately
  try {
    // Wait a tiny bit to let the DOM start loading
    setTimeout(function() {
      cleanupAdSense()
      logBlock('Initial cleanup complete')
    }, 0)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error in AdSense blocker:', e)
  }

  // Also run at various stages of page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupAdSense)
  } else {
    // If already loaded, run it again
    setTimeout(cleanupAdSense, 0)
  }

  // Run again after window load to catch late injections
  window.addEventListener('load', cleanupAdSense)
  
  // Run one final time after a delay (for late scripts)
  setTimeout(cleanupAdSense, 2000)
})()

// eslint-disable-next-line no-console
console.log(`${__BRANCH__} / ${__DATE__} / ${__REVISION__}`)

require('@/icons/figures.font')
require('./polyfills')

// Configure global logger to use instead of console.* methods
const log = window.log = require('loglevel')

const loggingLevelByHost = location.hostname === 'grecos.local' ? 'trace' : null
log.setDefaultLevel(loggingLevelByHost || 'warn')
log.info('Logging enabled')

import { extendMoment } from 'moment-range'

import VersioningApp from '@/versioningApp'

const moment = extendMoment(require('moment'))

moment.locale('pl')

const $ = require('jquery')

window.jQuery = window.$ = $
require('jquery-ui/ui/widget')
require('jquery-ui/ui/widgets/datepicker')
require('jquery-ui/ui/widgets/slider')
require('./libs/jquery-ui/datepicker-settings')
require('@/plugins/jquery.uppercase-first-letter')

require('bootstrap')
require('./plugins/bootstrap/bootstrap-select')
require('./plugins/bootstrap/bootstrap-datetime')

require('hammerjs')
require('slick-carousel')
require('sticky-kit')
require('datatables')

require('./helpers/handlebars')
require('./helpers/query-string')
require('./plugins/jquery.autoellipsis')
require('./plugins/perfect-scrollbar')

require('./modules/campaignTimer')
require('./modules/dynamicContentComponent')
window.FastMatcher = require('./modules/fastMatcher')

require('./app')

new VersioningApp().init()

window.jQuery = window.$ = $

require('./wffm/jquery.validate')
require('./wffm/jquery.validate.unobtrusive')
require('./wffm/wffm')
require('./wffm/main')

window.jQuery = window.$ = $


// WEBPACK FOOTER //
// ./src/index.js